import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { cloneDeep } from 'lodash';
import { AttachedChatFile } from '../canvas.model';
import { SnackbarService } from 'src/app/services/common/snackbar.service';

@Component({
  selector: 'app-add-chat-documents-dialog',
  templateUrl: './add-chat-documents-dialog.component.html',
  styleUrl: './add-chat-documents-dialog.component.scss',
})
export class AddChatDocumentsDialogComponent implements OnInit {
  fileSectionMapping: AttachedChatFile[] = [];

  constructor(
    private readonly dialogRef: MatDialogRef<AddChatDocumentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly snack: SnackbarService
  ) {}

  ngOnInit(): void {
    this.formFilesMapping();
  }

  removeFile(index: number) {
    this.data.filesSelected.splice(index, 1);
    this.fileSectionMapping.splice(index, 1);
    if (this.data.filesSelected.length === 0) {
      this.dialogRef.close({ uploading: false });
    }
  }

  onCancel() {
    this.dialogRef.close({ uploading: false });
  }

  getFileMapping() {
    return this.fileSectionMapping ?? [];
  }

  formFilesMapping() {
    let supplementalMapping: AttachedChatFile[] = [];
    for (let i = 0; i < this.data.filesSelected.length; i++) {
      let map =
        supplementalMapping?.length > 0
          ? supplementalMapping?.find(
              (m) => m.file_name == this.data.filesSelected[i].name
            )
          : null;
      this.fileSectionMapping.push({
        id: i + 1,
        file: this.data.filesSelected[i],
        linked_sections: map
          ? map.linked_sections
          : this.data.sectionPreselected ?? [],
        dataset_name: map?.dataset_name ?? '',
        datasource_name: map?.datasource_name ?? '',
        query_instructions: map?.query_instructions ?? '',
        description: map?.description ?? '',
        file_name: this.data.filesSelected[i].name,
      });
    }
  }

  uploadOtherDocuments() {
    let mapping = cloneDeep(this.getFileMapping() ?? []);
    if (mapping?.length > 0 && this.isValidMapping(mapping)) {
      this.dialogRef.close({ uploading: true, meta: mapping });
    }
  }

  isValidDescription(name: string) {
    return (
      String(name).toLocaleLowerCase().endsWith('.xls') ||
      String(name).toLocaleLowerCase().endsWith('.xlsx') ||
      String(name).toLocaleLowerCase().endsWith('.xlsm') ||
      String(name).toLocaleLowerCase().endsWith('.pdf') ||
      String(name).toLocaleLowerCase().endsWith('.csv')
    );
  }

  isValidMapping(mapping: AttachedChatFile[]) {
    if (
      mapping.some(
        (it: AttachedChatFile) =>
          this.isValidDescription(it.file_name) &&
          !it.description?.trim().length
      )
    ) {
      this.snack.openInfoBar('Description is mandatory.');
      return false;
    }
    return true;
  }
  getFillerRowClass() {
    const maxHeight = 400;
    const rowHeight = 60;
    const fillerHeight =
      maxHeight - this.fileSectionMapping?.length * rowHeight;
    if (fillerHeight <= 0) return '';
    const rounded = Math.ceil(fillerHeight / rowHeight) * rowHeight;
    return `filler-row-${rounded}`;
  }
  ngOnDestroy(): void {
    this.fileSectionMapping = [];
  }
}
